import { getMessage } from './MESSAGE';
import { jsx as _jsx } from "react/jsx-runtime";
export const getMessageComponent = ({
  messageKey
}) => {
  const message = getMessage(messageKey);
  if (message) {
    const MessageComponent = message.component;
    if (MessageComponent) {
      return () => /*#__PURE__*/_jsx("div", {
        "data-message-key": messageKey,
        children: /*#__PURE__*/_jsx(MessageComponent, {
          messageKey: messageKey
        })
      });
    }
  }
  return null;
};